import React, { Component } from 'react'
import '../styles/GlobalStyle.css'
import SuperAdminHeader from './SuperAdminHeader'
import { secondaryFirebaseRef, db } from '../firebase/Firebase'
import { getAvatarColor, getNumShards, compress, getEmptySchoolOrDistrictSummary, flattenDoc, linkAfterLogin } from '.././Util'
import ColType from '.././Types'
import { Icon, Select, Form, Input, Button, message, Checkbox } from 'antd'
const FormItem = Form.Item
const Option = Select.Option

const successMessage = (description) => {
  message.success(description)
}

const errorMessage = (description) => {
  message.error(description)
}

class AddInitialAdmin extends Component {
  state = {
    showNotDemo: false,
  }

  componentDidMount() {

  }

  signInUsingCleverId = (cleverId) => {
    if (!cleverId) {
      return
    }

    //console.log('cleverId', cleverId)

    db.collection(ColType.users)
      .doc(cleverId)
      .get()
      .then((doc) => {
        if (!doc.exists) {
          throw new Error('User does not exist');
        }
        var userInfo = flattenDoc(doc)
        if (userInfo.accessLevel === 'superAdmin') {
          window.location.href = '/super-admin/add-initial-admin'
          return
        }
        else {
          db.collection(userInfo.accessLevel)
            .doc(userInfo.refId)
            .get()
            .then((doc) => {
              var userJobInfo = flattenDoc(doc)
              linkAfterLogin(userInfo, userJobInfo)
            })
        }
      }).catch((error) => {
        console.log('get user info error', error)
        this.setState({
          submitting: false,
        })
      })
  }

  render() {
    return (
      <div>
        <SuperAdminHeader menuKey={'add-initial-admin'} />
        <div className="mainContainer">
          <div className="w-600 m-lr-auto p-4">
            <h1 className="mt-4 mb-2 font-30">
              Sign In
            </h1>

            <div>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_54f086516a3645bca253')
              }}>
                SC Large Demo Admin
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_05464e273f0349b28f22')
              }}>
                SC Large Demo Coach
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_00148dce92924da09476')
              }}>
                SC Large Demo Teacher
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_00028b498b924d60b170')
              }}>
                SC Large Demo Student
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('64bee2bdbd36861021732034')
              }}>
                SC Demo Admin
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('64c9bd88ee3bd703dc3f33f7')
              }}>
                SC Demo Coach
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('64c9bd88ee3bd703dc3f33ca')
              }}>
                SC Demo Teacher
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('64c9bd81ee3bd703dc3f282f')
              }}>
                SC Demo Student
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_01554c24889540efac4c')
              }}>
                KY Demo Admin
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_001f395bcbde4c689d1c')
              }
              }>
                KY Demo Coach
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_004420607d29438792da')
              }
              }>
                KY Demo Elementary School Teacher
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_00391a94c9e0460ab64d')
              }
              }>
                KY Demo Middle School Teacher
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_00f09e8fa0f14669863e')
              }
              }>
                KY Demo High School Teacher
              </Button>
              <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                this.signInUsingCleverId('demo_000b25e898774c139510')
              }}>
                KY Demo Student
              </Button>
              <div className='mt-4 mb-2'>
                <Checkbox checked={this.state.showNotDemo} onChange={(e) => {
                  this.setState({
                    showNotDemo: e.target.checked
                  })
                }}
                >
                  <span className='pl-1'>Show all</span>
                </Checkbox>
              </div>
              {this.state.showNotDemo ?
                <div>
                  <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                    this.signInUsingCleverId('cl_4690_t2051')
                    //this.signInUsingCleverId('5fa9eebb9ebc0b25ae1ff68b')
                  }}>
                    Dillon
                  </Button>
                  <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                    this.signInUsingCleverId('cl_5100_3056187')
                  }}>
                    Laurens
                  </Button>
                  <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                    this.signInUsingCleverId('5fa9aa4b5c99031aaa67a9e7')
                  }}>
                    Lincoln
                  </Button>
                  <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                    this.signInUsingCleverId('5fab9d718a744504192fe89d')
                  }}>
                    Elizabethtown
                  </Button>
                  <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                    this.signInUsingCleverId('5fab0a877995f912e53c1154')
                  }}>
                    Anderson
                  </Button>
                  <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                    this.signInUsingCleverId('cl_1100_t75334')
                  }}>
                    Beaufort
                  </Button>
                  <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                    this.signInUsingCleverId('cl_1100_t10701')
                  }}>
                    Beaufort Coach
                  </Button>
                  <Button className='lg-btn w-100 mb-1' onClick={(e) => {
                    this.signInUsingCleverId('cl_1100_a67502')
                  }}>
                    Beaufort Teacher
                  </Button>
                </div> : ''}
            </div>
          </div>
        </div>
      </div >
    )
  }
}

export default AddInitialAdmin
